const fetchTechnicianUsecase = (repository) => async (pagination, search, status, includeID) => {
    const payload = {
        sort: pagination.sortBy.map((s) => [s]).join(','),
        descending: pagination.sortDesc.join(','),
        page: pagination.page,
        itemsPerPage: pagination.itemsPerPage,
        search: search,
        status: status,
        includeID: includeID,
    }
    return await repository(payload);
}

export default fetchTechnicianUsecase;